/**
 * 登入頁可選的後端伺服器，登入後所有 API 請求都打到所選基底。
 * 選擇存於 localStorage key: apiServerId
 *
 * 111 測試：API 須與頁面**同源**（路徑前綴 `/api/tokyo`），由 staging-admin 轉發至 gateway-tokyo。
 * - 公網：`https://staging.xrross-soc.com/api/tokyo/...`（ALB 443 → 8089）
 * - 直連：`http://18.177.93.7:8089/api/tokyo/...`
 * **不可**在 HTTPS 頁內請求 `http://IP:8089`（Mixed Content 會被瀏覽器擋）。
 */

const STORAGE_KEY = 'apiServerId'

/** 公網 Staging 域名（與 deploy 之 Route53 / ALB 一致） */
const STAGING_PUBLIC_HOSTNAMES = ['staging.xrross-soc.com']

/**
 * 德國（或單機）管理後台：靜態頁與 API 同源，路徑前綴見 config/staging.env.js 的 VUE_APP_API_PREFIX（常為 /api/de）。
 * 若有正式域名，請加入此陣列。
 */
const GERMANY_ADMIN_HOSTS = ['47.91.78.139', 'de.xrross-soc.com']

/** 無 window 或非瀏覽器場景之後備（僅測試伺服器選項） */
const STAGING_HOST = 'http://18.177.93.7:8089'

export const SERVER_LIST = [
  { id: 'local', label: '本機環境', base: 'http://localhost:20000', prefix: '' },
  { id: 'test', label: '測試伺服器', base: STAGING_HOST, prefix: '/api/tokyo' }
]

const defaultBase = process.env.VUE_APP_BASE_API || ''
const defaultPrefix = process.env.VUE_APP_API_PREFIX || ''

export function getSelectedServerId() {
  try {
    const id = localStorage.getItem(STORAGE_KEY)
    if (id && SERVER_LIST.some((s) => s.id === id)) return id
  } catch (e) {}
  return SERVER_LIST[0] ? SERVER_LIST[0].id : 'local'
}

export function setSelectedServerId(id) {
  try {
    localStorage.setItem(STORAGE_KEY, id)
  } catch (e) {}
}

/**
 * 開發環境選「測試伺服器」時改走本機 dev 的 /__staging111 代理，否則瀏覽器直連 111 常被 CORS 擋成 Network Error。
 */
export function getApiBase() {
  const id = getSelectedServerId()
  const server = SERVER_LIST.find((s) => s.id === id)
  if (!server) return defaultBase + (defaultPrefix || '')

  if (
    id === 'test' &&
    process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    window.location &&
    window.location.origin
  ) {
    return `${window.location.origin}/__staging111${server.prefix || ''}`
  }

  // Staging dist：頁與 API 同源（HTTPS 或 http://IP:8089），避免 Mixed Content
  if (id === 'test' && typeof window !== 'undefined' && window.location) {
    const host = window.location.hostname
    const port = String(window.location.port || '')
    if (
      STAGING_PUBLIC_HOSTNAMES.includes(host) ||
      (host === '18.177.93.7' && port === '8089') ||
      GERMANY_ADMIN_HOSTS.includes(host)
    ) {
      const prefix = defaultPrefix || '/api/tokyo'
      return `${window.location.origin}${prefix}`
    }
  }

  return server.base + (server.prefix || '')
}



// WEBPACK FOOTER //
// ./src/config/apiServer.js